import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import ReactGA from 'react-ga';


class PassNotFound extends Component {

    tryAgainPressed(e){

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Enter Pass',
            action: 'Modal Try Again'
        });

        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.closeModal()
    }
    createPassPressed(e){

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Enter Pass',
            action: 'Modal Create New Pass'
        });

        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.closeModal()
        this.props.history.push('create_pass');
    }
    constructor(props){
        super(props);
        this.createPassPressed = this.createPassPressed.bind(this)
        this.tryAgainPressed = this.tryAgainPressed.bind(this)
    }

    render() {
        return(
            <div className="modalMessage">
              <div className="title">Invalid Confirmation Code</div>
              <button
                className="bigButton"
                onClick={this.tryAgainPressed}>
                  Try Again
              </button>
              <button onClick={this.createPassPressed}>
                 Create New Pass
              </button>
            </div>
        );
    }
}

PassNotFound = inject('DGRStore','DGRModalStore')(observer(PassNotFound ))
export default PassNotFound ;



// WEBPACK FOOTER //
// ./src/components/DGR/Modal/PassNotFound.js